import { render, staticRenderFns } from "./file_upload.vue?vue&type=template&id=6d0985fa&scoped=true&"
import script from "./file_upload.vue?vue&type=script&lang=ts&"
export * from "./file_upload.vue?vue&type=script&lang=ts&"
import style0 from "./file_upload.vue?vue&type=style&index=0&id=6d0985fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0985fa",
  null
  
)

export default component.exports